export default class ProjectsLoader {
    constructor($element) {
        this.$element = $element;
        this.page = Math.max(1, parseInt(this.$element.attr('data-page'))) + 1;
        this.taxonomy = this.$element.attr('data-taxonomy');

        this.request = null;

        this.$columns = this.$element.find('.js-projects-columns');
        this.$loadButtonWrapper = this.$element.find('.js-projects-load-more-wrapper');
        this.$loadButton = this.$element.find('.js-projects-load-more');
        this.$mesageContainer = this.$element.find('.js-message-container');

        this.bindEvents();
    }

    bindEvents() {
        this.$loadButton.on('click', () => {
            this.loadNextPage();
            return false;
        });
    }

    loadNextPage() {
        if (this.$loadButton.is('.btn--loading')) {
            return;
        }
        this.$loadButton.addClass('btn--loading');

        if (this.request !== null) {
            this.request.abort();
        }

        this.hideErrorMessages();

        this.request = Ajax.get('eotw', 'projects', {page: this.page, taxonomy: this.taxonomy});

        this.request.then((data) => {
            if (data.status === 'success' && typeof data.data !== 'undefined') {
                this.handleData(data.data);
                this.page++;
            } else {
                this.showErrorMessage('Could not load projects, please try again');
            }
            this.$loadButton.removeClass('btn--loading');
        }).catch((e) => {
            this.request = null;
            this.showErrorMessage(e.message);
            this.$loadButton.removeClass('btn--loading');
        });
    }

    handleData(data) {
        if (typeof data.html !== 'undefined') {
            let scrollTop = $(window).scrollTop();
            this.$columns.append(data.html);
            window.scrollTo({
                top: scrollTop,
                behavior: "instant",
            });
        } else {
            this.showErrorMessage('Could not load projects, please try again');
        }

        if (this.page >= data.totalPages) {
            this.$loadButtonWrapper.hide();
        } else {
            this.$loadButtonWrapper.show();
        }
    }

    showErrorMessage(message = 'Something went wrong, please try again.') {
        this.$mesageContainer.append((
            eotwJSXFactory('div', {className: "message"}, [
                eotwJSXFactory('p', {className: "square"}, [message])
            ])
        ));
    }

    hideErrorMessages() {
        this.$mesageContainer.html('');
    }
}